// apps/web/src/views/app-views/lead-forms/index.js

import React, { useEffect, useState } from "react";
import {
  Card,
  Table,
  Button,
  Space,
  Tag,
  message,
  Popconfirm,
} from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LeadFormService from "services/LeadFormService";

const LeadFormsIndex = () => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);

    try {
      const res = await LeadFormService.list();
      setData(Array.isArray(res) ? res : []);
    } catch (err) {
      message.error("Erro ao carregar formulários");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const remove = async (id) => {
    try {
      await LeadFormService.remove(id);
      message.success("Formulário removido");
      load();
    } catch (err) {
      message.error("Erro ao remover formulário");
    }
  };

  const columns = [
    {
      title: "Nome",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Game ID",
      dataIndex: "gameId",
      key: "gameId",
      render: (value) => value || "-",
    },
    {
      title: "Evento ID",
      dataIndex: "eventId",
      key: "eventId",
      render: (value) => value || "-",
    },
    {
      title: "Status",
      dataIndex: "isEnabled",
      key: "isEnabled",
      render: (value) =>
        value ? (
          <Tag color="green">Ativo</Tag>
        ) : (
          <Tag color="red">Inativo</Tag>
        ),
    },
    {
      title: "Antes do jogo",
      dataIndex: "showBeforeGame",
      key: "showBeforeGame",
      render: (value) =>
        value ? (
          <Tag color="blue">Sim</Tag>
        ) : (
          <Tag color="default">Não</Tag>
        ),
    },
    {
      title: "Leads",
      key: "leads",
      render: (_, row) => row?._count?.leads || 0,
    },
    {
      title: "Ações",
      key: "actions",
      render: (_, row) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            onClick={() => navigate(`/app/lead-forms/${row.id}`)}
          >
            Editar
          </Button>

          <Popconfirm
            title="Remover formulário?"
            description="Essa ação também remove os campos e leads vinculados."
            okText="Sim"
            cancelText="Não"
            onConfirm={() => remove(row.id)}
          >
            <Button danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Card
      title="Formulários de Captação"
      extra={
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => navigate("/app/lead-forms/new")}
        >
          Novo formulário
        </Button>
      }
    >
      <Table
        rowKey="id"
        loading={loading}
        columns={columns}
        dataSource={data}
      />
    </Card>
  );
};

export default LeadFormsIndex;